import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { QuoteService } from '../services/quote.service';
import { Quote } from '../../shared/models/quote.interface';
import { User } from '../../shared/models/user.interface';
import { QuoteFilter } from '../models/quote.filter';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {RolePermission } from '../../shared/models/role.permission.enum';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { ConvertDialog } from '../convert-dialog/convert.dialog';
import { JobType } from '../../shared/models/job.type.interface';

export interface DealerQuoteSummary {
  quoteCount: number;
  salespersons: User[];
  jobTypes: JobType[];
}

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent extends AbstractBiditComponent {
  quotes: Quote[] = [];

  summary: DealerQuoteSummary;

  filter: QuoteFilter = { salespersonId: '', dateRange: null, jobTypeId: null, statusId: '1' } as QuoteFilter;
  canAddQuote: boolean = false;
  canAddJob: boolean = false;

  constructor(private router: Router, private deviceDetectorService: DeviceDetectorService, private dialog: MatDialog, protected quoteService: QuoteService) {
    super(deviceDetectorService);
  }

  init() {
    this.canAddQuote = QuoteService.hasPermission(RolePermission.AddQuote);
    this.canAddJob = QuoteService.hasPermission(RolePermission.AddJob);    

    this.loadSummary();
  } 

  loadSummary(): void {
    this.quoteService.getSummary(this.filter)
      .subscribe({
        next: (data) => {
          this.summary = data;
        },
        error: (error: string) => this.onError(error)
      }); 
  }

  convertQuote(quote: Quote): void {
    const dialogRef = this.dialog.open(ConvertDialog, {
      data: {
        quote: quote
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.router.navigate(['/job/' + quote.quote_ID]);
      }
    });
  } 

}
